export const XRAY_OPERATING_POSE_CONNECTIONS: ReadonlyArray<readonly [number, number]> = [
    [0, 11], [0, 12],
    [11, 12],
    [11, 13], [13, 15],
    [12, 14], [14, 16],
    [11, 23], [12, 24], [23, 24],
    [23, 25], [25, 27], [27, 29], [29, 31],
    [24, 26], [26, 28], [28, 30], [30, 32],
    [27, 31], [28, 32],
];

export const XRAY_OPERATING_POSE_STYLE = Object.freeze({
    line: '#38bdf8',
    point: '#0ea5e9',
    pointStroke: '#ffffff',
    lineWidth: 0.004,
    pointRadius: 0.006,
    pointStrokeWidth: 0.002,
});
